export default new class CatalogTag {
  constructor() {
    this.catalogTagButton = 'catalog-tag__button';
    this.catalogTagHiddenButton = 'catalog-tag__button_hidden';
    this.catalogTagListClass = 'catalog-tag__list';
    this.catalogTagListHiddenClass = 'catalog-tag__list_hidden';

    this.init();
  }

  init() {
    $(document)
      .on('click', `.${this.catalogTagButton}`, () => {
        $(`.${this.catalogTagButton}`)
          .addClass(this.catalogTagHiddenButton);
        $(`.${this.catalogTagListClass}`)
          .removeClass(this.catalogTagListHiddenClass);
      });
  }
}();
